export const PUBLISH_DATA_REQUEST = 'PUBLISH_DATA_REQUEST'
export const PUBLISH_DATA_SUCCESS = 'PUBLISH_DATA_SUCCESS'
export const PUBLISH_DATA_FALIURE = 'PUBLISH_DATA_FALIURE'
